import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutRightFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutRightFull"><Path d="M3 21V3H13.5L13.5 21L3 21Z" fill="currentColor"/><Path d="M15 21L21 21V3H15L15 21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutRightFull;
